export default __webpack_public_path__ + "static/media/network.40f158e8.svg";